import numeral from 'numeral';

export const toCurrency = (value) => {
  if (value === undefined) return '';
  const price = value.toString();
  if (!price) return '';
  return numeral(price).format('0,0.00');
};

export const toDecimal = (value) => {
  if (value === undefined) return '';
  const price = value.toString();
  if (!price) return '';
  return numeral(price).format('0,0');
};
